import React from "react";
import { Helmet } from "react-helmet";
import Layout from "./Layout";

function About() {
  return (
    <Layout customClass="content-area">
      <Helmet>
        <title>About - Instant QR Codes</title>
        <met
          name="description"
          content="About InstantQRCodes.com and it's workings, Learn all about qr codes and our free qr code generator."
        />
        <link rel="canonical" href="https://instantqrcodes.com/about/" />
      </Helmet>
      <h3>About</h3>
      <p>
        InstantQRCodes is a simple and efficient tool to create QR code for
        variety of uses. We believe this tools will help you to generate QR
        codes easily. Our tool is and will always be 100% free to use, and we
        have plans to introduce more options in near future. So, stay tuned!
      </p>
      <p>
        In case, if you have any comments or queries, you can mail us directly
        at contact@instantqrcodes.com
      </p>
    </Layout>
  );
}

export default About;
